import React from "react";
import Usernav from "./Usernav";
import Sellernav from "./Sellernav";
import Adminnav from "./Adminnav";
import ReactPaginate from "react-paginate";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import Cards from "./Cards";
import axios from "axios";
import BaseURL from "../Util/BaseURL";
import emptyResult from "../assets/image/No result.svg"
import Loader from "../Util/Loader";
const SearchResults = () => {
  const location = useLocation();
  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = 4;
  const pagesVisited = pageNumber * usersPerPage;
  const [pageCount, setPageCount] = useState();
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const [products, setProducts] = useState([]);
  const getProducts = async () => {
    const response = await axios.get(
      `${BaseURL}searchProduct?size=4&startPage=${pageNumber}&name=${location.state.search}`
    );
    setPageCount(Math.ceil(response.data.totalPages));
    setProducts(response.data.content);
  };
  useEffect(() => {
    getProducts();
  }, [pageNumber]);
  return (
    <>
      {sessionStorage.getItem("c") === "User" ? (
        <Usernav />
      ) : sessionStorage.getItem("c") === "Seller" ? (
        <Sellernav />
      ) : sessionStorage.getItem("c") === "Admin" ? (
        <Adminnav />
      ) : (
        <Usernav />
      )}
      {products ? 
      <>
      {products.length === 0 ? 
      <>
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">no results found</h1>
          </div>
        </div>
      </section>
      <img
                src={emptyResult}
                className="d-block d-xl-none d-lg-none d-md-none"
                style={{ width: "100%" }}
              />
              <img
                src={emptyResult}
                className="d-none d-xl-block d-lg-block d-md-block mx-auto"
                style={{ width: "35%" }}
              />
      </> : 
      <>
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">Search Results</h1>
          </div>
        </div>
      </section>
      <div className="row row-cols-lg-4 row row-cols-md-3 row-cols-sm-1 total h-100 w-100 mx-auto">
        {products ? products.map((data,key) => <Cards key={key} data={data} />) : ""}
      </div>
      <div className="totalpagebtn h-100 w-100">
        <ReactPaginate
          previousLabel={<i className="fas fa-angle-double-left"></i>}
          nextLabel={<i className="fas fa-angle-double-right"></i>}
          pageCount={pageCount}
          onPageChange={changePage}
          containerClassName={"paginationBttns"}
          previousLinkClassName={"previousBttn"}
          nextLinkClassName={"nextBttn"}
          disabledClassName={"paginationDisabled"}
          activeClassName={"paginationActive"}
        />
      </div>
      </>}
      </> 
      : 
      <>
      {Loader()}
      </>}
      
      
    </>
  );
};

export default SearchResults;
